import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Insights from '../components/Insights';
import CTA from '../components/CTA';

function StatsBar() {
  const stats = [
    { value: '50+', label: 'Years of Excellence' },
    { value: '120+', label: 'Global Offices' },
    { value: '85%', label: 'Fortune 500 Clients' },
    { value: '$2B+', label: 'Value Delivered (YTD)' },
  ];

  return (
    <section className="bg-slate-900 border-t border-slate-800 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-slate-800">
          {stats.map((stat, index) => (
            <div key={index} className={`flex flex-col ${index !== 0 ? 'pl-8' : ''}`}>
              <span className="text-4xl md:text-5xl font-serif text-amber-500 mb-2">{stat.value}</span>
              <span className="text-sm font-medium text-slate-400 uppercase tracking-wider">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [hash]);

  return (
    <>
      <Hero />
      <StatsBar />
      <Services />
      <div id="about" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-amber-600 font-semibold tracking-wider uppercase text-sm mb-3">Our Identity</h2>
              <h3 className="text-4xl font-serif text-slate-900 mb-6">A legacy of excellence, a future of innovation.</h3>
              <p className="text-slate-600 text-lg leading-relaxed mb-8">
                Founded over five decades ago, Eldenwyck & Co. has stood at the intersection of business strategy and transformative technology. We don't just advise; we partner with our clients to navigate the most complex industrial shifts of our time.
              </p>
              <div className="space-y-4">
                {['Integrity in every interaction', 'Data-driven decision making', 'Long-term value creation'].map(point => (
                  <div key={point} className="flex items-center gap-3 text-slate-900 font-medium">
                    <div className="w-1.5 h-1.5 bg-amber-600 rounded-full"></div>
                    {point}
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              {/* Fixed image URL for better reliability */}
              <img 
                src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&q=80&w=1000" 
                className="w-full h-auto shadow-2xl grayscale hover:grayscale-0 transition-all duration-700 aspect-[4/3] object-cover" 
                alt="Eldenwyck Boardroom" 
              />
              <div className="absolute -bottom-8 -left-8 bg-amber-600 p-8 text-white hidden md:block max-w-xs shadow-xl">
                <p className="font-serif text-2xl italic">"Excellence is not an act, but a habit."</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Insights />
      <CTA />
    </>
  );
}